import {Component, Input} from '@angular/core';
import {TileType252} from "../../../models";
import {
    ParametersService,
    SubtitlesService,
    TilesService
} from "../../../core";

@Component({
    selector: 'tile-opentherm',
    templateUrl: './tile-opentherm.component.html',
    styleUrls: ['./tile-opentherm.component.scss']
})
export class TileOpenthermComponent {
    @Input() tile: TileType252;

    constructor(
        private parameters: ParametersService,
        public subtitles: SubtitlesService,
        private tiles: TilesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    openSubmenu() {
        this.tiles.openSubmenu(this.tile.elementMenu);
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor' : 'setting'
    }
}
